import './App.css';
import { Navbar } from './Components/Navbar';
import { AllRouters } from './Routers/AllRouters';

function App() {
  return (
    <div className="App">
    <Navbar />
    <AllRouters />
    </div>
  );
}

export default App;
